import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { toast } from "react-toastify";
import { Button, Col, Row } from "../../components/Component";
import { POST } from "../../helper/api";
import {
  REQUEST_UPDATE_STATUS,
  getDefaultCustomerMoneyFlow
} from "../../utils/Utils";
import UpsertCustomerMoneyFlowComponent from "./upsertcustomermoneyflowcomponent/UpsertCustomerMoneyFlowComponent";

const CustomerMoneyFlowPreviewUpdate = ({ data: { data, reason, customerMoneyFlowId }, onSuccess }) => {

  const methodForm = useForm({
    defaultValues: {
      ...getDefaultCustomerMoneyFlow()
    },
    shouldFocusError: true,
  });
  const { reset, control, setValue, register, errors } = methodForm;

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    reset({
      ...data,
      reason,
    });
  }, []);

  const actionRequestUpdate = (status) => {
    setLoading(true);
    POST(
      `/customer-money-flow/action-request-update/${customerMoneyFlowId}`,
      {
        status,
      },
      {},
      true
    )
      .then((res) => {
        toast.success("Cập nhật thành công");
        onSuccess()
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <h3>
          Sửa tiền {data?.type === "IN" ? "thu" : "chi"}

        </h3>
        <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
          <div className="my-3">
            <FormProvider {...methodForm}>
              <UpsertCustomerMoneyFlowComponent disabledForm={true} type={data?.type} />
              <Row>
                <Col size="12" className="position-relative">
                  <div className="form-overlay"></div>
                  <div className="form-group">
                    <label className="form-label" >
                      Lý do cập nhật<span className="text-danger">*</span>
                    </label>
                    <div className="form-control-wrap">
                      <textarea
                        rows={3}
                        className="form-control"
                        style={{ height: "unset" }}
                        name="reason"
                        ref={register({
                          required: "Vui lòng nhập thông tin",
                        })}
                      />
                      <ErrorMessage errors={errors} name="reason" render={({ message }) => <span className="invalid">{message}</span>} />
                    </div>
                  </div>
                </Col>
                <Col size="12" >
                  <div className="form-group">
                    <label className="form-label" >
                      Chức năng duyệt đơn cho quản lý:
                    </label>
                    <div className="form-control-wrap mt-2">
                      <Button color="primary" type="button" className={"mr-2"} onClick={() => actionRequestUpdate(REQUEST_UPDATE_STATUS.APPROVED)}>
                        <span>Chấp nhận</span>
                      </Button>
                      <Button color="primary" type="button" className={"mr-2"} onClick={() => actionRequestUpdate(REQUEST_UPDATE_STATUS.REJECTED)}>
                        <span>Từ chối</span>
                      </Button>
                    </div>
                  </div>
                </Col>

              </Row>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerMoneyFlowPreviewUpdate;
